/* eslint-disable @typescript-eslint/no-var-requires */
// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 as uuidv4 } from 'uuid';
import { AccessProductCardList, Environment, Product, ProductCardList } from '../types';

function createRedirectUrl(url: string, environment: Environment | null): string {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call
    const stateUuid: string = uuidv4();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-assignment
    const nonceUuid: string = uuidv4();

    const accountsUrl =
        environment === Environment.STAGING
            ? 'https://accounts-staging.falcon.io/auth/realms/falcon/protocol/openid-connect/auth?'
            : 'https://accounts.falcon.io/auth/realms/falcon/protocol/openid-connect/auth?';

    return (
        accountsUrl +
        'client_id=falcon' +
        '&redirect_uri=' +
        encodeURIComponent(url) +
        '&state=' +
        stateUuid +
        '&response_type=code' +
        '&scope=openid' +
        '&nonce=' +
        nonceUuid +
        '&kc_idp_hint=brandwatch-oidc'
    );
}

function selectUrl(environment: Environment | null, stagingUrl: string, productionUrl: string): string {
    if (environment === Environment.STAGING) {
        return stagingUrl;
    }

    return productionUrl;
}
export const productList: AccessProductCardList[] = [
    {
        id: Product.CONSUMER_RESEARCH,
        icon: (require('!!raw-loader?!../../assets/icons/consumer-research.svg') as { default: string }).default,
        name: `Consumer Research`,
        description: 'Get deep insights into your consumers, brand, and industry',
        createUrl: (environment: Environment) =>
            selectUrl(
                environment,
                'https://app.stage.brandwatch.net/login?idp_hint=falcon-fso',
                'https://app.brandwatch.com/login?idp_hint=falcon-fso'
            ),
    },
    {
        id: Product.LISTEN,
        icon: (require('!!raw-loader?!../../assets/icons/listen.svg') as { default: string }).default,
        name: 'Listen',
        description: 'Get real-time data on conversations about your brand and industry',
        createUrl: (environment) =>
            selectUrl(
                environment,
                createRedirectUrl('https://staging.falcon.io/#/listen/listen-by-brandwatch', environment),
                createRedirectUrl('https://app.falcon.io/#/listen/listen-by-brandwatch', environment)
            ),
    },
    {
        id: Product.PUBLISH,
        icon: (require('!!raw-loader?!../../assets/icons/publish.svg') as { default: string }).default,
        name: `Publish`,
        description: 'Plan and publish all your social content from one calendar',
        createUrl: (environment) =>
            selectUrl(
                environment,
                createRedirectUrl('https://staging.falcon.io/#/publish/calendar/weekly', environment),
                createRedirectUrl('https://app.falcon.io/#/publish/calendar/weekly', environment)
            ),
    },
    {
        id: Product.ENGAGE,
        icon: (require('!!raw-loader?!../../assets/icons/engage.svg') as { default: string }).default,
        name: 'Engage',
        description: 'Manage all your social engagement in one inbox',
        createUrl: (environment) =>
            selectUrl(
                environment,
                createRedirectUrl('https://staging.falcon.io/#/engage/overview', environment),
                createRedirectUrl('https://app.falcon.io/#/engage/overview', environment)
            ),
    },
    {
        id: Product.MEASURE,
        icon: (require('!!raw-loader?!../../assets/icons/measure.svg') as { default: string }).default,
        name: 'Measure',
        description: 'Track and analyse your social performance and create reports',
        createUrl: (environment) =>
            selectUrl(
                environment,
                createRedirectUrl('https://staging.falcon.io/#/measure/dashboards/home', environment),
                createRedirectUrl('https://app.falcon.io/#/measure/dashboards/home', environment)
            ),
    },
    {
        id: Product.ADVERTISE,
        icon: (require('!!raw-loader?!../../assets/icons/ads.svg') as { default: string }).default,
        name: `Advertise`,
        description: 'Create, schedule and test campaigns across all your social channels',
        createUrl: (environment) =>
            selectUrl(
                environment,
                createRedirectUrl('https://staging.falcon.io/#/ads', environment),
                createRedirectUrl('https://app.falcon.io/#/ads', environment)
            ),
    },
    {
        id: Product.AUDIENCE,
        icon: (require('!!raw-loader?!../../assets/icons/audience.svg') as { default: string }).default,
        name: `Audience`,
        description: 'Create individual profiles for social interactions to improve your service',
        createUrl: (environment) =>
            selectUrl(
                environment,
                createRedirectUrl('https://staging.falcon.io/#/audience', environment),
                createRedirectUrl('https://app.falcon.io/#/audience', environment)
            ),
    },
    {
        id: Product.INFLUENCE,
        icon: (require('!!raw-loader?!../../assets/icons/influence.svg') as { default: string }).default,
        name: `Influence`,
        description: 'Discover and engage influencers, and manage your campaigns with them',
        createUrl: (environment) =>
            selectUrl(
                environment,
                createRedirectUrl('https://accounts-stage.influence.brandwatch.com/auth/falcon', environment),
                createRedirectUrl('https://accounts.paladinsoftware.com/auth/falcon', environment)
            ),
    },
    {
        id: Product.BENCHMARK,
        icon: (require('!!raw-loader?!../../assets/icons/benchmark.svg') as { default: string }).default,
        name: `Benchmark`,
        description: 'Analyse your social performance and create reports',
        createUrl: (environment) =>
            selectUrl(
                environment,
                createRedirectUrl('https://staging.falcon.io/#/benchmark/brand-insights', environment),
                createRedirectUrl('https://app.falcon.io/#/benchmark/brand-insights', environment)
            ),
    },
    {
        id: Product.VIZIA,
        icon: (require('!!raw-loader?!../../assets/icons/vizia.svg') as { default: string }).default,
        name: `Vizia`,
        description: 'Analyse your social performance and create reports',
        createUrl: (environment) =>
            selectUrl(environment, 'https://admin.vizia-stage.gcp0.bwcom.net', 'https://admin.vizia.brandwatch.com'),
    },
];

export const exploreProductList: ProductCardList[] = [
    {
        id: Product.CONSUMER_RESEARCH,
        icon: (require('!!raw-loader?!../../assets/icons/consumer-research.svg') as { default: string }).default,
        name: `Consumer Research`,
        description: 'Drive social campaigns based off impactful conversations from your consumers, brand and industry',
        url: 'https://www.brandwatch.com/products/consumer-research/',
    },
    {
        id: Product.LISTEN,
        icon: (require('!!raw-loader?!../../assets/icons/listen.svg') as { default: string }).default,
        name: 'Listen',
        description:
            'Understand what content resonates with your audience and react faster to trends with real-time data',
        url: 'https://www.brandwatch.com/products/listen/',
    },
    {
        id: Product.PUBLISH,
        icon: (require('!!raw-loader?!../../assets/icons/publish.svg') as { default: string }).default,
        name: `Publish`,
        description: 'Plan and publish all your social content from one calendar',
        url: 'https://www.brandwatch.com/products/publish/',
    },
    {
        id: Product.ENGAGE,
        icon: (require('!!raw-loader?!../../assets/icons/engage.svg') as { default: string }).default,
        name: 'Engage',
        description: 'Manage all your social engagement in one inbox',
        url: 'https://www.brandwatch.com/products/engage/',
    },
    {
        id: Product.MEASURE,
        icon: (require('!!raw-loader?!../../assets/icons/measure.svg') as { default: string }).default,
        name: 'Measure',
        description: 'Track and analyse your social performance and create reports',
        url: 'https://www.brandwatch.com/products/measure/',
    },
    {
        id: Product.ADVERTISE,
        icon: (require('!!raw-loader?!../../assets/icons/ads.svg') as { default: string }).default,
        name: `Advertise`,
        description: 'Save time with automated campaigns and optimize your ads using the content that performs best',
        url: 'https://www.brandwatch.com/products/advertise/',
    },
    {
        id: Product.AUDIENCE,
        icon: (require('!!raw-loader?!../../assets/icons/audience.svg') as { default: string }).default,
        name: `Audience`,
        description:
            'Improve your customer service with individual profiles showing interactions with your brand across social',
        url: 'https://www.brandwatch.com/products/audience/',
    },
    {
        id: Product.INFLUENCE,
        icon: (require('!!raw-loader?!../../assets/icons/influence.svg') as { default: string }).default,
        name: `Influence`,
        description: 'Discover influencers for your brand, build relationships, and manage campaigns all in one place',
        url: 'https://www.brandwatch.com/products/influence/',
    },
    {
        id: Product.BENCHMARK,
        icon: (require('!!raw-loader?!../../assets/icons/benchmark.svg') as { default: string }).default,
        name: `Benchmark`,
        description: 'Understand how your performance on social compares to competitors and industry leaders',
        url: 'https://www.brandwatch.com/products/benchmark/',
    },
    {
        id: Product.VIZIA,
        icon: (require('!!raw-loader?!../../assets/icons/vizia.svg') as { default: string }).default,
        name: `Vizia`,
        description: 'Drive a data-led culture in your organization with live reports and real-time displays',
        url: 'https://www.brandwatch.com/products/vizia/',
    },
];
